import { configureStore } from '@reduxjs/toolkit';
import jobReducer from './job-slice';
const store = configureStore({
    reducer: {
      jobs: jobReducer,
    } /* preloadedState, */,
  });
  
  export default store;